<button mat-icon-button (click)="btnNew()" matTooltip="Add new row">
  <mat-icon>add_circle</mat-icon>
</button>
<button mat-icon-button (click)="btnRefresh()" matTooltip="Refresh the current table">
  <mat-icon>refresh</mat-icon>
</button>
<br />

<table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8 mat-table-custom">
  <ng-container matColumnDef="ItemNo">
    <th mat-header-cell *matHeaderCellDef>Item no.</th>
    <td mat-cell *matCellDef="let element; index as i">{{ i + 1 }}</td>
  </ng-container>

  <ng-container matColumnDef="ControllerType">
    <th mat-header-cell *matHeaderCellDef>Controller type</th>
    <td mat-cell *matCellDef="let element">{{ element.controllerType }}</td>
  </ng-container>

  <ng-container matColumnDef="Enable">
    <th mat-header-cell *matHeaderCellDef>Enabled</th>
    <td mat-cell *matCellDef="let element">{{ element.enable ? 'Yes' : 'No' }}</td>
  </ng-container>

  <ng-container matColumnDef="SendInterval">
    <th mat-header-cell *matHeaderCellDef>Send interval</th>
    <td mat-cell *matCellDef="let element">{{ element.sendInterval }}</td>
  </ng-container>

  <ng-container matColumnDef="ReportingInterval">
    <th mat-header-cell *matHeaderCellDef>Reporting interval</th>
    <td mat-cell *matCellDef="let element">{{ element.reportingInterval }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td class="actionscolumn th-center" mat-cell *matCellDef="let element">
      <button mat-icon-button matTooltip="Edit row" (click)="onRowEdit(element)">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Delete row" (click)="onDelete(element)">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay" class="opmode-item"></tr>
</table>